<div *ngIf="!isListMode">
  <div class="content-wrapper" *ngIf="!display">
    <div>
      <div>
        <div class="btn-wrapper">
          <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.btnBack' | translate}}</span>
          </button>
          <span class="spacer"></span>
          <button [disabled]="!userForm.valid" mat-flat-button color="" class="btn-primary" aria-label="Save"
            (click)='saveMatrixQuestion()'>
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.btnSave' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
    <form [formGroup]="userForm">
      <ng-container>
        <div class="filter-section">
          <div class="body-section title addFlex">
            <mat-icon>library_add</mat-icon> &nbsp;
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.title' | translate}}</span>
          </div>
          <div class="body-section-2" formGroupName="questiondescription">
            <label class="que-label">{{'questions.typeOfQuestions.matrixSingleChoice.labelQuest' | translate}}</label>
            <ckeditor #myEditor1 formControlName="description" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
            <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <!-- <ckeditor data="Enter here..." [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()" formControlName="description" [config]="ckeditorConfig"> -->
            <!-- </ckeditor> -->
          </div>
        </div>
        <div *ngIf="validateQuestion" class="text-msg">
          <span>{{'questions.typeOfQuestions.matrixSingleChoice.errorQuestion' | translate}}</span>
        </div>
      </ng-container>

      <div>
        <div class="filter-section">
          <div class="body-section title"> <span>{{'questions.typeOfQuestions.matrixSingleChoice.labelStem' |
              translate}}</span> </div>
        </div>
        <div class="body-section-2">
          <ckeditor #myEditor2 [formControlName]="reuseProp.tempStem" [editor]="Editor" (ready)="onReadyStem($event)">
          </ckeditor>
          <div *ngIf="errorMessageStem" class="alert alert-danger">{{ errorMessageStem }}</div>
          <!-- <ckeditor [formControlName]="reuseProp.tempStem" [config]="ckeditorConfig"></ckeditor> -->
        </div>
        <div class="btn-container">
          <button mat-flat-button color="" (click)='validateAndAddStem()'
            class="btn-warn">{{'questions.typeOfQuestions.matrixSingleChoice.btnAddStem' | translate}}</button>
        </div>
        <div class="filter-section">
          <div class="body-section title">
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.labelStemsText' | translate}}</span>
          </div>
        </div>
        <div class="body-section-2">
          <div class="score-wrapper">
            <div class="add-option">
              <div class="input-class-container" cdkDropList
                (cdkDropListDropped)="dragAndDropEventHandler($event, 'stems')">
                <ul class="add-metrix-ul">
                  <li class="add-metrix-list d-flex"
                    *ngFor="let o of this.userForm.controls[reuseProp.stems].value; let i = index" cdkDrag>
                    <div class="metrix-list-wrapper alphabetic-list">
                      <div class="metrix-list-desc Jaytest">
                        <ng-component [innerHTML]="o?.stemdescription.description | sanitizeHtml"></ng-component>
                        <div class="drag-box" *cdkDragPreview>
                          <span [innerHtml]="o?.answerDescription?.description"></span>
                        </div>
                      </div>
                      <div class="metrix-menu-icon">
                        <div class="mat-icon-div">
                          <button mat-icon-button
                            matTooltip="{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.edit' | translate}}"
                            (click)="openDialog(o, true, i)">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-icon-button
                            matTooltip="{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.delete' | translate}}"
                            [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                            (click)="removeArrayItem(i, reuseProp.stems)">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                          <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openDialog(o, true)">
                              <mat-icon>edit</mat-icon>
                              <span>
                                {{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.edit' | translate}}
                              </span>
                            </button>
                            <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true"
                              (click)="removeArrayItem(i, reuseProp.stems)">
                              <mat-icon>delete_outline</mat-icon>
                              <span>
                                {{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.delete' | translate}}
                              </span>
                            </button>
                          </mat-menu> -->
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- && this.userForm.controls[reuseProp.stems].value.length -->
      <div>
        <div class="filter-section">
          <div class="body-section title">
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.labelOption' | translate}}</span>
          </div>
        </div>
        <div class="body-section-2">
          <ckeditor #myEditor3 [formControlName]="reuseProp.tempOption" [editor]="Editor" (ready)="onReadyProp($event)">
          </ckeditor>
          <div *ngIf="errorMessageProp" class="alert alert-danger">{{ errorMessageProp }}</div>
          <!-- <ckeditor [formControlName]="reuseProp.tempOption" [config]="ckeditorConfig"></ckeditor> -->
        </div>
        <div class="btn-container">
          <button mat-flat-button color="" (click)='validateAndAddOption()'
            class="btn-warn">{{'questions.typeOfQuestions.matrixSingleChoice.btnAddOptions' | translate}}</button>
        </div>
        <div class="filter-section">
          <div class="body-section title">
            <span>{{'questions.typeOfQuestions.matrixSingleChoice.labelOptionsText' | translate}}</span>
          </div>
        </div>
        <div class="body-section-2">
          <div class="score-wrapper ">
            <div class="add-option">
              <div class="input-class-container" cdkDropList
                (cdkDropListDropped)="dragAndDropEventHandler($event, 'options')">
                <ul class="add-metrix-ul">
                  <li class="add-metrix-list d-flex"
                    *ngFor="let o of this.userForm.controls[reuseProp.options].value; let i = index" cdkDrag>
                    <div class="metrix-list-wrapper alphabetic-list">
                      <div class="metrix-list-desc">
                        <ng-component [innerHTML]="o?.answerDescription?.description | sanitizeHtml"></ng-component>

                        <div class="drag-box" *cdkDragPreview>
                          <span [innerHtml]="o?.answerDescription?.description"></span>
                        </div>
                      </div>
                      <div class="metrix-menu-icon">
                        <div class="mat-icon-div">
                          <button mat-icon-button
                            matTooltip="{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.edit' | translate}}"
                            (click)="openDialog(o, false, i)">
                            <mat-icon>edit</mat-icon>
                          </button>
                          <button mat-icon-button
                            matTooltip="{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.delete' | translate}}"
                            [ngClass]="{'disableIcon': roleSer.accessData? !roleSer.accessData.deleteAllowed:true}"
                            (click)="removeArrayItem(i, reuseProp.options)">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                          <!-- <button mat-icon-button class="action-button" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openDialog(o, false)">
                              <mat-icon>edit</mat-icon>
                              <span>{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.edit' | translate}}</span>
                            </button>
                            <button mat-menu-item [disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true"
                              (click)="removeArrayItem(i, reuseProp.options)">
                              <mat-icon>delete_outline</mat-icon>
                              <span>{{'questions.typeOfQuestions.matrixSingleChoice.addOptions.toolTip.delete' | translate}}</span>
                            </button>
                          </mat-menu> -->
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10 p-0" *ngIf="isQuestionAdded">
        <div class="flex-container">
          <div class="matrix-table-block">
            <div class="question-block">
              <div class="block-layer"></div>
              <div class="question-wrapper horizontal-view-truefalse">
                <mat-radio-group name="radioButtons">
                  <div *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
                    <label class="Questions-score">{{'questions.typeOfQuestions.matrixSingleChoice.labelQuestScore' |
                      translate}}</label>
                    <input value="newEvent" formControlName="correctPoints" class="form-control scoreInput" readonly>
                  </div>
                  <div *ngIf="scoringType == ScoringTypeEnum.OnOption">
                    <label class="Questions-score">
                      <h3><strong>{{'questions.typeOfQuestions.standard.labelSetScore' | translate}}</strong></h3>
                    </label>
                  </div>
                  <table class="metrix-table add-metrix-table" *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
                    <thead>
                      <tr class="metrix-list-row">
                        <th>{{'questions.typeOfQuestions.matrixSingleChoice.labelScore' | translate}}</th>
                        <th>
                          <ng-component
                            [innerHtml]="userForm.controls[reuseProp.questiondescription].value[reuseProp.description] | sanitizeHtml"></ng-component>
                        </th>
                        <th class="text-center " *ngFor="let o of this.userForm.controls[reuseProp.options].value">
                          <div class="editor">
                            <ng-component [innerHTML]="o?.answerDescription?.description | sanitizeHtml"></ng-component>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let stem of this.userForm.controls[reuseProp.stems].value, let i = index">
                        <td class="input-table-data">
                          <!-- <input type="number" [(ngModel)]="stem.correctPointsforStem"
                            [ngModelOptions]="{standalone: true}" min="0" max="9999" step=".01"
                          onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                          (keypress)="omit_special_char($event)" (keyup)="replace2Decimall($event, stem)"
                          (change)="stem.correctPointsforStem=myProp.value; calculateScore();" class="scoreInput"
                            #myProp > -->

                            <input type="number" min="0" max="9999.99" step=".01" value="" [(ngModel)]="stem.correctPointsforStem"
                            [ngModelOptions]="{standalone: true}" (input)="validateInput($event, stem, 'options')" (keypress)="omit_special_char($event)"
                            (change)="stem.correctPointsforStem=myProp.value; calculateScore();" class="scoreInput" #myProp>

                          <!-- <input type="number" [(ngModel)]="stem.correctPointsforStem" [ngModelOptions]="{standalone: true}" min="0" max="9999"
                            (change)="stem.correctPointsforStem=myProp.value; calculateScore();" class="scoreInput" #myProp> -->
                        </td>
                        <td>
                          <div class="metrix-list-wrapper alphabetic-list metrix-list-desc">
                            <ng-component [innerHTML]="stem?.stemdescription.description | sanitizeHtml"></ng-component>
                          </div>
                        </td>
                        <td class="text-center" *ngFor="let option of this.userForm.controls[reuseProp.options].value">
                          <mat-radio-group name="{{i}}" fxLayout="column">
                            <mat-radio-button class="question-mat-radio" (change)="stem.validchoiceid = option.optionId"
                              [checked]="option.optionId===stem.validchoiceid" [value]="option.optionId">
                            </mat-radio-button>
                          </mat-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="metrix-table add-metrix-table1" *ngIf="scoringType == ScoringTypeEnum.OnOption">
                    <thead>
                      <tr class="metrix-list-row">
                        <th>
                          <ng-component
                            [innerHtml]="userForm.controls[reuseProp.questiondescription].value[reuseProp.description] | sanitizeHtml"></ng-component>
                        </th>
                        <th class="options " *ngFor="let o of this.userForm.controls[reuseProp.options].value">
                          <!-- <div class="editor"> -->
                          <ng-component [innerHTML]="o?.answerDescription?.description | sanitizeHtml"></ng-component>
                          <!-- </div> -->
                        </th>
                      </tr>
                    </thead>
                    <tbody *ngIf="isEditMode">
                      <tr *ngFor="let stem of this.userForm.controls[reuseProp.stems].value, let i = index">
                        <td>
                          <div class="metrix-list-wrapper alphabetic-list metrix-list-desc">
                            <ng-component [innerHTML]="stem?.stemdescription.description | sanitizeHtml"></ng-component>
                          </div>
                        </td>
                        <td class="options"
                          *ngFor="let option of this.userForm.controls[reuseProp.options].value; let j = index;">
                          <!-- <input type="number" name="{{i}}" min="0" max="9999" step=".01"
                            [(ngModel)]="option.optionScores[i].points" [ngModelOptions]="{standalone: true}"
                          onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                          (keypress)="omit_special_char($event)" (keyup)="replace2Decimal($event, option.optionScores[i], 'edit')"
                          (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp> -->

                          <input type="number" name="{{i}}" class="form-control" min="0" max="9999.99" step=".01" value="" [(ngModel)]="option.optionScores[i].points" [ngModelOptions]="{standalone: true}"
                          (input)="validateInput($event, option.optionScores[i], 'edit')" (keypress)="omit_special_char($event)"
                          (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp>

                          <!-- <input type="number" name="{{i}}" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                            [(ngModel)]="option.optionScores[i].points" [ngModelOptions]="{standalone: true}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                            onkeypress="if(this.value.length == 4 ) return false;"
                            (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp> -->
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="!isEditMode">
                      <tr *ngFor="let stem of this.userForm.controls[reuseProp.stems].value, let i = index">
                        <td>
                          <div class="metrix-list-wrapper alphabetic-list metrix-list-desc">
                            <ng-component [innerHTML]="stem?.stemdescription.description | sanitizeHtml"></ng-component>
                          </div>
                        </td>
                        <td class="options"
                          *ngFor="let option of this.userForm.controls[reuseProp.options].value; let j = index;">
                          <!-- <input type="number" name="{{i}}" min="0" max="9999" step=".01" [(ngModel)]="option.optionScores[i].points" [ngModelOptions]="{standalone: true}"

                          onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                          (keypress)="omit_special_char($event)" (keyup)="replace2Decimal($event, option.optionScores[i], 'new')"
                          (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp> -->

                          <input type="number" name="{{i}}" class="scoreInput" min="0" max="9999.99" step=".01" value="" [(ngModel)]="option.optionScores[i].points" [ngModelOptions]="{standalone: true}"
                          (input)="validateInput($event, option.optionScores[i], 'new')" (keypress)="omit_special_char($event)"
                          (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp>

                          <!-- <input type="number" name="{{i}}" min="0" max="9999" onkeydown="if(event.key==='.'){event.preventDefault();}"
                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                            onkeypress="if(this.value.length == 4 ) return false;"
                            (change)="optionScoring(stem, option, myProp.value)" class="scoreInput" #myProp> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 p-0" *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
        <div class="col-md-12 p-0">
          <div class="exp-panel">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'questions.typeOfQuestions.matrixSingleChoice.accordian.title' | translate}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="container-fluid  body-section-2">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="scoring-check">
                        <mat-checkbox name="autoscoring" formControlName="autoScoring"
                          [disabled]="true"><b>{{'questions.typeOfQuestions.matrixSingleChoice.accordian.checkbox' |
                            translate}}</b> </mat-checkbox>
                        <!-- <div  class="invalid-feedback">
                                  <div>Field is required</div>
                                </div> -->
                      </div>
                    </div>
                    <br>
                    <br>

                    <div class="col-md-2">
                      <div class="scoring-check">
                        <div class="invalid-feedback">
                          <!-- <div>Field is required</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
                    <div class="col-md-2">
                      <div class="form-label">
                        <label>{{'questions.typeOfQuestions.matrixSingleChoice.accordian.selectOptions.option1.label' |
                          translate}}</label>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <mat-form-field class="scoring-type " appearance="fill">

                        <mat-select formControlName="scoringTypeExactMatch">
                          <mat-option [value]="option.id == 1 ? 'true' : 'false'"
                            *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                        </mat-select>
                        <div class="invalid-feedback">
                          <!-- <div>Field is required</div> -->
                        </div>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- <div class="row" *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
                    <div class="col-md-2">
                      <div class="form-label">
                        <label>{{'questions.typeOfQuestions.matrixSingleChoice.accordian.selectOptions.option1.label' |
                          translate}}</label>
                      </div>
                    </div>
                    <div class="scoring-type-w">
                      <mat-form-field class="scoring-type " appearance="fill" style="margin-left:19px">

                        <mat-select formControlName="scoringTypeExactMatch">
                          <mat-option [value]="option.id == 1 ? 'true' : 'false'"
                            *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                        </mat-select>
                        <div class="invalid-feedback">
                        </div>
                      </mat-form-field>
                    </div>
                  </div> -->
                  <div class="row items-center" *ngIf="scoringType == ScoringTypeEnum.OnQuestion">
                    <!-- <div class="col-md-2">
                      <label
                        class="form-label score-labels">{{'questions.typeOfQuestions.matrixSingleChoice.accordian.selectOptions.option2'
                        | translate}}</label>
                    </div>
                    <div class="col-md-2 mrg-right">
                      <input [formControlName]="reuseProp.penaltyPoints" class="form-control penalty-points"
                        type="number" value="" min="0" [attr.disabled]="true">

                    </div>
                    <div
                      *ngIf="!userForm.get(reuseProp.penaltyPoints).valid && userForm.get(reuseProp.penaltyPoints).touched">
                      Required and only zero or positive numbers allowed
                    </div> -->
                    <div class="col-md-2">
                      <label class="form-label score-labels"
                        required>{{'questions.typeOfQuestions.matrixSingleChoice.accordian.selectOptions.option3.label'
                        | translate}}</label>
                    </div>
                    <div class="col-md-3">
                      <!-- <input [formControlName]="reuseProp.minScoreIfAttempt" type="number" min="0" max="9999"
                        class="form-control" onkeypress="if(this.value.length == 4 ) return false;"
                        oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                        <!-- <input type="number" min="0" step=".01" class="form-control" [formControlName]="reuseProp.minScoreIfAttempt"
                          onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                          (keypress)="omit_special_char($event)" (keyup)="replace2Decimal($event, userForm.get(reuseProp.minScoreIfAttempt).value, 'minimumScore')"> -->

                          <input type="number" class="form-control" min="0" max="9999.99" step=".01" [formControlName]="reuseProp.minScoreIfAttempt"
                          (input)="validateInput($event, userForm.get(reuseProp.minScoreIfAttempt).value, 'minimumScore')" (keypress)="omit_special_char($event)">
                      <div
                        *ngIf="!userForm.get(reuseProp.minScoreIfAttempt).valid && (userForm.get(reuseProp.minScoreIfAttempt).touched || userForm.get(reuseProp.minScoreIfAttempt).dirty)"
                        class="alert alert-danger zero">
                        {{'questions.typeOfQuestions.matrixSingleChoice.accordian.selectOptions.option3.errorMsg1' |
                        translate}}
                      </div>

                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="display">
  <app-choose-question-type></app-choose-question-type>
</div>

<div *ngIf="isListMode">
  <app-question-list></app-question-list>
</div>
